// extracted by mini-css-extract-plugin
export default {"w-full":"File_w-full__nB-1I","label":"File_label__qU6YL","tooltip":"File_tooltip__BHAFc","wrap":"File_wrap__2soNk","input":"File_input__SBMKC","box":"File_box__MGu5d"};